import { useCallback } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import db from '../firebase/firestore';
import { useAuth } from '../auth/useAuth';

export function getSessionId() {
  let id = sessionStorage.getItem('_ts_sid');
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);
    sessionStorage.setItem('_ts_sid', id);
  }
  return id;
}

export function useTrackEvent() {
  const { user } = useAuth();

  return useCallback((eventType, data = {}) => {
    if (!user) return;
    try {
      const p = addDoc(collection(db, 'usage_events'), {
        userId:    user.uid,
        eventType,
        sessionId: getSessionId(),
        timestamp: serverTimestamp(),
        ...data,
      });
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch {}
  }, [user]);
}
